import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';

import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateModal({
  createInput,
  createApprehendingOfficer,
  formData,
  getSettings,
  history,
  showApprehendingOfficer,
  getRoleList,
  creating,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    createApprehendingOfficer(formData, ({ data }) => {
      setModal({ isOpen: false });
      getSettings();
      history.push(
        `/ordinance-violation-receipts/settings/apprehending-officers/${_.get(
          data,
          'id'
        )}`
      );
      showApprehendingOfficer(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getRoleList();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Officer Name' },
              { required: true, placeholder: 'Input officer name' }
            )}
            {createInput(
              { key: 'dno', label: 'DNO' },
              { required: true, placeholder: 'Input DNO', maxlength: '13' },
            )}
            {createInput(
              { key: 'ecode', label: 'ECODE' },
              { required: true, placeholder: 'Input ECODE', maxlength: '13' },
            )}
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  getSettings: PropTypes.instanceOf(Function).isRequired,
  createApprehendingOfficer: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showApprehendingOfficer: PropTypes.instanceOf(Function).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_APPREHENDING_OFFICER) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
